import React from 'react'

import Map from './Map'
import {ServicesControl, MapModControl} from './LeafletControls'

const MapWithControls = ({serviceIds, toggleShowPositioningBounds, onSetServiceIds, children, ...propsToTransfert}) => {
  return <Map {...propsToTransfert}>
    <ServicesControl serviceIds={serviceIds} onSetServiceIds={onSetServiceIds}/>
    <MapModControl toggleShowPositioningBounds={toggleShowPositioningBounds} />
    {children}
  </Map>
}
export default MapWithControls



/** WEBPACK FOOTER **
 ** ./app/components/MapWithControls.jsx
 **/